import {
    GET_USERNAME_CONTACT_SUGGESTION_SUCCESS,
    GET_USERNAME_CONTACT_SUGGESTION_FAILED,
    LOADING_GET_USERNAME_CONTACT_SUGGESTION,
    NETWORK_ERROR_GET_USERNAME_CONTACT_SUGGESTION
} from "../types/index";
import { partnerServices } from "../../config/axios";

const getUsernameContactSuggestion =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GET_USERNAME_CONTACT_SUGGESTION });
        await partnerServices
            .post("getUsernameContactSuggestion", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: GET_USERNAME_CONTACT_SUGGESTION_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: GET_USERNAME_CONTACT_SUGGESTION_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_GET_USERNAME_CONTACT_SUGGESTION,
                    payload: err
                });
            });
    };

export { getUsernameContactSuggestion };
